import { FC } from 'react';
import { Tooltip } from 'react-tooltip';
import { ReactComponent as RedInfoIcon } from 'assets/redInfo.svg';
import { IErrorIconProps } from './types';
import styles from './errorIcon.module.scss';

export const ErrorIcon: FC<IErrorIconProps> = ({ name, message, stylesProp }) => {
  return (
    <div className={styles.errorIcon} style={stylesProp} data-type='error-icon'>
      <RedInfoIcon data-tip data-tooltip-id={name} />
      <Tooltip place='right' id={name} delayHide={250}>
        <span className={styles.errorMsg}>{message}</span>
      </Tooltip>
    </div>
  );
};
